import React from 'react';
import { Icon } from './Icon.js';
export const IconFollowObjDownLeftFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.513.487c-.293-.293-.768-.293-1.061,0l-2.952,2.952v-1.939c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.75c0,.414.336.75.75.75h3.75c.414,0,.75-.336.75-.75s-.336-.75-.75-.75h-1.939l2.952-2.952c.293-.293.293-.768,0-1.061Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("rect", { y: "6", width: "6", height: "6", rx: "1.75", ry: "1.75", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconFollowObjDownLeftFill12.js.map